import React from "react";
import { bool, node, string } from "prop-types";
import {
	spacingClassName,
	spacingProps,
	spacingPropTypes,
} from "@insightfulscience/atomic-react/props/spacing";
import { classes } from "../utils/classes";

const Table = ({
	className = "",
	isStriped = false,
	isBottomBorderedStriped = false,
	isBottomBordered = false,
	isBordered = false,
	isBorderedWrapper = false,
	children,
	spacing = { ...spacingProps },
	...props
}) => {
	return (
		<table
			className={classes(
				"table",
				isBottomBordered && "table-bottom-bordered",
				isBottomBorderedStriped && "table-bottom-bordered-striped",
				isBordered && "table-bordered",
				isBorderedWrapper && "table-bordered-wrapper",
				isStriped && "table-striped",
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		>
			{children}
		</table>
	);
};

Table.propTypes = {
	className: string,
	isBottomBordered: bool,
	isBordered: bool,
	isBorderedWrapper: bool,
	isStriped: bool,
	isBottomBorderedStriped: bool,
	children: node.isRequired,
	spacing: spacingPropTypes,
};

export default Table;
